import SelectAutocomplete from './select-autocomplete';
import './styles.scss';

export default SelectAutocomplete;
